module.exports = __webpack_public_path__ + "56b45eca2301cc6a367e7c4533ebcc8a.png";